import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CaInputDirective } from '@global-front-components/ui/input';
import { Router } from '@angular/router';
import { AuthService } from '../../../comun/services/api/auth.service';
import { AuthStoreService } from '../../../comun/services/store/auth-store.service';

@Component({
	selector: 'app-login',
	standalone: true,
	imports: [
		CommonModule,
		CaButtonComponent,
		CaFormFieldComponent,
		CaInputDirective,		
		CaLabel,
		ReactiveFormsModule,
		TranslateModule
	],
	templateUrl: './login.view.html',
	styleUrls: ['./login.view.scss']
})
export class LoginView implements OnInit {
	public loginForm: FormGroup;
  
	constructor(
	  private formBuilder: FormBuilder,
	  private authService: AuthService,
	  private authStore: AuthStoreService,
	  private router: Router
	) {}
  
	ngOnInit(): void {
	  if (this.authStore.isLoggedIn()) {
		this.router.navigate(['/']);
		return;
	  }
  
	  this.loginForm = this.formBuilder.group({
		usuario: ['', Validators.required],
		password: ['', Validators.required]
	  });
	}
  
	login(): void {
	  if (this.loginForm.invalid) return;
  
	  const { usuario, password } = this.loginForm.value;

	  this.authService.login(usuario, password).subscribe({
		next: () => this.router.navigate(['/']),
		error: () => (new Error('Usuario o contraseña incorrectos'))
	  });
	}
  }